import { create } from 'zustand';
import { doGet } from '../../http';
import { isGroupOfHotels } from '../../utils';

export const createHotelInfoSlice = (set, get) => ({
  hotelInfo: null,
  fetchHotelInfo: async () => {
    const hotelId = get().config?.hotelId;

    if (!hotelId) {
      console.warn('Failed to fetch hotel info: No Hotel ID.');
      return;
    };

    try {
      const res = await doGet(({ baseUrl, hotelId }) => `${baseUrl.replace('/v3', '/v2')}/hotels/info?id=${hotelId}`, {
        'content-type': 'application/json',
      });
      const data = await res.json();

      if (import.meta.env.VITE_LOG_HOTEL_DATA) {
        console.log('fetchHotelInfo:', data);
      }

      set({ hotelInfo: data });

      if (isGroupOfHotels(data)) {
        get().fetchHotelGroup();
      }
    } catch (err) {
      console.error('Failed to fetch hotel info', err);
    }
  },
});
